import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoice3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-3, wave"><path d="M21.9998 12C19.4998 9.95 19.6873 4.825 17.6373 4.825C15.5873 4.825 15.5873 9.95 13.0248 9.95C10.4623 9.95 10.4623 1.75 7.89976 1.75C5.33726 1.75 4.74023 9.5 2 12C4.74023 14.5 5.33726 22.25 7.89976 22.25C10.4623 22.25 10.4623 14.05 13.0248 14.05C15.5873 14.05 15.5873 19.175 17.6373 19.175C19.6873 19.175 19.4998 14 21.9998 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVoice3;
